/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type {
  CommunicationListResponse,
  CreateThrottleConfigBody,
  ListThrottleEventsParams,
  ThrottleConfigListResponse,
  ThrottleConfigResponse,
  ThrottleEventListResponse,
  ThrottleEventResponse,
  UpdateThrottleConfigBody,
} from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Lists all email throttle configs
 */
export const listThrottleConfigs = (
  options?: SecondParameter<
    typeof backofficeRequest<ThrottleConfigListResponse>
  >,
) => {
  return backofficeRequest<ThrottleConfigListResponse>(
    { url: `/communication/throttle/configs`, method: "GET" },
    options,
  )
}
/**
 * @summary Creates a new email throttle config
 */
export const createThrottleConfig = (
  createThrottleConfigBody: CreateThrottleConfigBody,
  options?: SecondParameter<typeof backofficeRequest<ThrottleConfigResponse>>,
) => {
  return backofficeRequest<ThrottleConfigResponse>(
    {
      url: `/communication/throttle/configs`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createThrottleConfigBody,
    },
    options,
  )
}
/**
 * @summary Updates an existing email throttle config
 */
export const updateThrottleConfig = (
  id: number,
  updateThrottleConfigBody: UpdateThrottleConfigBody,
  options?: SecondParameter<typeof backofficeRequest<ThrottleConfigResponse>>,
) => {
  return backofficeRequest<ThrottleConfigResponse>(
    {
      url: `/communication/throttle/configs/${id}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateThrottleConfigBody,
    },
    options,
  )
}
/**
 * @summary Lists email throttle events
 */
export const listThrottleEvents = (
  params?: ListThrottleEventsParams,
  options?: SecondParameter<
    typeof backofficeRequest<ThrottleEventListResponse>
  >,
) => {
  return backofficeRequest<ThrottleEventListResponse>(
    { url: `/communication/throttle/events`, method: "GET", params },
    options,
  )
}
/**
 * @summary Resumes a throttled email event, requeuing held emails
 */
export const resumeThrottleEvent = (
  id: number,
  options?: SecondParameter<typeof backofficeRequest<ThrottleEventResponse>>,
) => {
  return backofficeRequest<ThrottleEventResponse>(
    { url: `/communication/throttle/events/${id}/resume`, method: "POST" },
    options,
  )
}
/**
 * @summary Discards a throttle event, dropping the held emails
 */
export const discardThrottleEvent = (
  id: number,
  options?: SecondParameter<typeof backofficeRequest<ThrottleEventResponse>>,
) => {
  return backofficeRequest<ThrottleEventResponse>(
    { url: `/communication/throttle/events/${id}/discard`, method: "POST" },
    options,
  )
}
/**
 * @summary Lists all communications, for populating the throttle config template dropdown
 */
export const listCommunications = (
  options?: SecondParameter<
    typeof backofficeRequest<CommunicationListResponse>
  >,
) => {
  return backofficeRequest<CommunicationListResponse>(
    { url: `/communication/throttle/communications`, method: "GET" },
    options,
  )
}
export type ListThrottleConfigsResult = NonNullable<
  Awaited<ReturnType<typeof listThrottleConfigs>>
>
export type CreateThrottleConfigResult = NonNullable<
  Awaited<ReturnType<typeof createThrottleConfig>>
>
export type UpdateThrottleConfigResult = NonNullable<
  Awaited<ReturnType<typeof updateThrottleConfig>>
>
export type ListThrottleEventsResult = NonNullable<
  Awaited<ReturnType<typeof listThrottleEvents>>
>
export type ResumeThrottleEventResult = NonNullable<
  Awaited<ReturnType<typeof resumeThrottleEvent>>
>
export type DiscardThrottleEventResult = NonNullable<
  Awaited<ReturnType<typeof discardThrottleEvent>>
>
export type ListCommunicationsResult = NonNullable<
  Awaited<ReturnType<typeof listCommunications>>
>
